import { Directive, forwardRef, OnInit } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidatorFn, AbstractControl } from '@angular/forms';

import { EmailValidator } from './email-validator';

@Directive({
    selector: '[email][formControlName],[email][formControl],[email][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => EmailValidatorDirective),
            multi: true
        }
    ],
    standalone: false
})
export class EmailValidatorDirective implements Validator, OnInit {
  private validator: ValidatorFn;

  ngOnInit() {
    this.validator = EmailValidator.validate;
  }

  validate(c: AbstractControl): { [key: string]: any } {
    return this.validator(c);
  }
}
